
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnere",
      function () {
        return require("private-next-pages/partnere.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnere"])
      });
    }
  